import type { Trope } from "@/routes/innovation-days-demo/types";

interface TropesContentProps {
  tropes: Trope[];
}

export function TropesContent({ tropes }: TropesContentProps) {
  return (
    <div className="space-y-4">
      {tropes.map((t) => (
        <div key={t.title} className="relative pl-4">
          {/* Left accent bar */}
          <div
            className="absolute left-0 top-0 bottom-0 w-1 rounded-full"
            style={{ background: "#6366F1" }}
          />

          <div className="space-y-1.5">
            {/* Trope title */}
            <h4
              className="text-[15px] leading-[20px] font-semibold"
              style={{ color: "#0F172A" }}
            >
              {t.title}
            </h4>

            {/* Trope description */}
            <p
              className="text-[14px] leading-[20px]"
              style={{ color: "#64748B" }}
            >
              {t.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
